export const easeOut = [0.23, 1, 0.32, 1] as const;

/** Shared reveal timing for page-entrance animations. */
export const reveal = { duration: 0.6, ease: easeOut };

export const inViewOnce = { once: true, amount: 0.25 } as const;
